module.exports = __webpack_public_path__ + "img/UPSUM.419f3558.svg";